import { DynamicImage } from "@components/misc"
import { SliderArrow } from "@components/slider"
import { container, FlexBox } from "@components/wrapper"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@constants/pictures"
import { StudentTestimonial } from "@interfaces/school"
import MiscServices from "@lib/api/services/misc.services"
import { useIsMounted } from "@lib/hooks/useIsMounted"
import TestimonialRow from "@modules/program/components/general/TestimonialRow"
import clsx from "clsx"
import Image from "next/image"
import { useEffect, useState } from "react"
import Carousel, { DotProps } from "react-multi-carousel"
import { HeaderBootcamp } from "./HeaderBootcamp"

const TestimonialCard = ({ value }: { value: StudentTestimonial }) => {
  if (!value) {
    return <></>
  }

  return (
    <FlexBox
      direction="col"
      justify="between"
      className={clsx(
        "relative sm:py-[18px] sm:px-[26px] sm:h-[18em] bg-white shadow-[0_2px_15px_0_#9aaacf33] sm:w-auto",
        "w-full px-7 py-7"
      )}
    >
      <div className={clsx("lg:leading-6 sm:h-[9rem] mb-6", "leading-[22px]")}>
        {value.testimony}
      </div>

      <FlexBox justify="between" align="end">
        <FlexBox align="center" className="gap-2.5">
          <div className="rounded w-[60px] h-[60px]">
            <Image
              src={value.testimony_user_picture}
              alt={value.testimony_username}
              width={60}
              height={60}
            />
          </div>
          <div className="text-sm">
            <div className="font-urbanist font-semibold sm:text-lg">{value.testimony_username}</div>
            <div className="text-[#909090] text-sm">{value.testimony_user_as}</div>
          </div>
        </FlexBox>

        <div className="max-w-[35%] h-auto object-contain">
          {value.company && (
            <DynamicImage
              height={60}
              width={40}
              src={value.company.company_picture}
              alt={value.company.company_name}
              className="h-auto max-w-[60px] max-h-[40px] object-contain"
            />
          )}
        </div>
      </FlexBox>
      {value.testimony_url_linkedin ? (
        <div className="underline-animation">
          <button
            onClick={() => (window.location.href = value.testimony_url_linkedin as string)}
            className="text-new-blue font-semibold"
          >
            Baca di Linkedin
          </button>
        </div>
      ) : (
        <div className="h-8" />
      )}
    </FlexBox>
  )
}

export function BootcampTestimonial({ screenWidth }: { screenWidth: number }) {
  // const [isLoading, setIsLoading] = useState(true)
  const [testimonials, setTestimonials] = useState<StudentTestimonial[]>([])

  const misc = new MiscServices()
  const isMounted = useIsMounted()

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await misc.getTestimonials("school")

        if (res.isSuccess) {
          const data = res.getValue()
          setTestimonials(data)
        }

        // setIsLoading(false)
      } catch (e: any) {
        // school.bugsnagNotifier(e)
        // setIsLoading(false)
      }
    }

    if (isMounted) {
      getData()
    }
  }, [isMounted])

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  if (!testimonials.length) {
    return <></>
  }

  return (
    <section className="bg-body-bg">
      <div className={clsx("relative lg:py-10 pt-6 pb-[58px]", screenWidth > 576 && container)}>
        <div className="absolute sm-only:left-[35%]">
          <Image
            src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/testimonial_quote.png`}
            height={88}
            width={105}
            alt="quote"
          />
        </div>

        <HeaderBootcamp
          title={
            <>
              <span className="text-blue">Testimoni</span> Alumni
            </>
          }
          subTitle="  Yang mereka rasakan selama mengikuti program harisenin.com"
        />

        <div>
          <TestimonialRow screenWidth={screenWidth} testimonials={testimonials} />
        </div>
      </div>
    </section>
  )
}
